var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "CardsTitle",
        { staticClass: "mb-4", attrs: { title: _vm.cardsListTitle } },
        [
          _c("PaymentCardsList", {
            attrs: {
              paymentCards: _vm.paymentCards,
              processing: _vm.chosenCardProcessing,
            },
            on: { chooseCard: _vm.onChooseCard },
          }),
        ],
        1
      ),
      _c(
        "CardsTitle",
        { attrs: { title: _vm.cardFormTitle } },
        [
          _c("AddPaymentCardForm", {
            attrs: {
              currentUserId: _vm.currentUserId,
              outerProcessing: _vm.cardFormProcessing,
              outerErrorMessage: _vm.errorMessage,
              buttonText: "Edit credit card",
            },
            on: { addCard: _vm.onAddCard },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }